/**
 * The six starting styles. Descriptions and stops match
 * backend/services/style_dials.py PRESETS.
 */
// approved by Joel Oct 26
export const STYLE_PRESETS = [
  {
    id: 'cozy',
    name: 'Cozy',
    description: 'Warm and gentle. Small comforts, kind people, and trouble that never gets too dark.',
    dials: { closeness: 4, pace: 3, sentences: 3, words: 2 },
  },
  {
    id: 'gritty',
    name: 'Gritty',
    description: 'Rough and honest. Plain words, hard choices, and nobody comes out clean.',
    dials: { closeness: 4, pace: 4, sentences: 2, words: 1 },
  },
  {
    id: 'breakneck',
    name: 'Breakneck',
    description: 'Fast. Short sentences, lots happening, and no stopping to explain.',
    dials: { closeness: 3, pace: 5, sentences: 1, words: 1 },
  },
  {
    id: 'epic',
    name: 'Epic',
    description: 'Big and sweeping. Wide places, high stakes, and the feeling that history is watching.',
    dials: { closeness: 2, pace: 3, sentences: 4, words: 4 },
  },
  {
    id: 'quiet-and-close',
    name: 'Quiet and Close',
    description: "Close inside one person's head. Small moments, what they notice, and what they leave unsaid.",
    dials: { closeness: 5, pace: 2, sentences: 3, words: 2 },
  },
  {
    id: 'gothic',
    name: 'Gothic',
    description: 'Dark and moody. Old houses, buried secrets, and dread that builds slowly.',
    dials: { closeness: 4, pace: 3, sentences: 5, words: 5 },
  },
];
